import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './initialState';

const ApplicationStateSlice = createSlice({
    name: 'applicationState',
    initialState: initialState,
    reducers: {
        addFTUShownUserIds: (state, action) => {
            state.ftuShownUserIds = (state.ftuShownUserIds ?? []).concat(action.payload);
        },
        addFTUShownUSerPolicyIds: (state, action) => {
            state.ftuShownUserPolicyIds = (state.ftuShownUserPolicyIds ?? []).concat(action.payload);
        },
        setCookiesEnabled: (state, action) => {
            state.cookiesEnabled = action.payload;
        }
    }
});

export const { addFTUShownUserIds, addFTUShownUSerPolicyIds, setCookiesEnabled } = ApplicationStateSlice.actions;

export default ApplicationStateSlice.reducer;
